import styled from 'styled-components'

export const CheckToggle = styled.div.attrs ({
  type: 'button'
})`
  width: 12px;
  height: 12px;
  outline: ${({ color }) => `2px solid ${color}`};
  background-color: transparent;
  border-radius: 50%;
  margin-right: 5px;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
`

export const ToggleMark = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
`
